import React from 'react'
import { Row, Col, Table } from 'antd'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine } from 'recharts';

const LineCharttt = () => {
    const data = [
        {
            name: '6am',
            uv: 60,
            pv: 60,
            // amt: 2400,
        },
        {
            name: '7am',
            uv: 55,
            pv: 42,
        },
        {
            name: '8am',
            uv: 15,
            pv: 22,
        },
        {
            name: '9am',
            uv: 78,
            pv: 12,
        },
        {
            name: '10am',
            uv: 65,
            pv: 0,
        },
        {
            name: '11am',
            uv: 78,
            pv: 20,
        },
        {
            name: '12am',
            uv: 85,
            pv: 40,
        },
        {
            name: '1pm',
            uv: 34,
            pv: 60,
        },
        {
            name: '2pm',
            uv: 34,
            pv: 80,
        },
        {
            name: '3pm',
            uv: 30,
            pv: 100,
        },
    ];
    return (
        <>
            <div style={{ width: "100%", height: 180 }}>
                <ResponsiveContainer>
                    <LineChart
                        data={data}
                        style={{
                            fontSize: "12px"
                        }}
                    >
                        <XAxis dataKey="name" />
                        <YAxis />
                        {/* <Tooltip /> */}
                        {/* <Legend /> */}
                        <Line type="" dataKey="pv" stroke="red"  axisLine={false} dot={false} />
                        <Line type="monotone" dataKey="uv"  axisLine={false} dot={false}/>
                        <ReferenceLine y={80} stroke="#1EA849" strokeDasharray="5 5" />

                    </LineChart>
                </ResponsiveContainer>
            </div>
        </>
    )
}

export default LineCharttt